import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
// import {
//   getAllOcspList,
//   removeEventFlag,
// } from '../../store/feature/satpasDevice';
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";
import LogEventsSearch from "../../components/molecules/keyUsageLog/KeyUsageLogSearch";
import LogEventsTable from "../../components/molecules/keyUsageLog/KeyUsageLogTable";
import { useGetKeySignListQuery } from "../../store/feature/service/logEventsApiSlice";

const KeyUsageLog = () => {
  // const dispatch = useAppDispatch();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});


  // REGION: DISPATCH OCSP ALL
  // useEffect(()=> {
  //   dispatch(getAllOcspList(params))
  // },[params])

  const { data: dataLogEvents, isLoading } = useGetKeySignListQuery(params);

  useEffect(() => {
    console.log("hahaha ===> ", dataLogEvents);
  }, [dataLogEvents]);
  // console.log('data aja aada ', dataLogEvents)
  // console.log('data aja aada ', dataLogEvents.events)
  // REGION: DISPATCH SUCCESS EVENT
  // useEffect(() => {
  //   if (eventFlag) {
  // dispatch(getAllOcspList(params));
  // dispatch(removeEventFlag());
  //   }
  // }, [eventFlag]);

  // REGION: RETURN TSX
  return (
    <ListDataSkeleton
      isLoading={isLoading}
      // isLoadingEvent={isLoadingEvent}
      titleWidth={"300px"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
        >
          Key Usage Log
        </Typography>
        <LogEventsSearch params={params} setParams={setParams} />
        <LogEventsTable
          data={dataLogEvents !== undefined ? dataLogEvents : []}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default KeyUsageLog;
